import { Session } from 'next-auth';
import { SessionProvider, useSession } from 'next-auth/react';

export interface AuthenticationContextProviderProps {
	children?: React.ReactNode;
	session: Session;
}

export const AuthenticationContextProvider = (props: AuthenticationContextProviderProps) => {
	return (
		<SessionProvider session={props.session} basePath="/oversigt/api/auth">
			{props.children}
		</SessionProvider>
	);

};

export const useAuthenticationContext = (): Authentication.Session => {
	const { data: session, status } = useSession();
	return {
		isLoggedIn: status === 'authenticated',
		expires: session?.expires ? new Date(session.expires) : null,
		user: session?.user,
		accessToken: session?.accessToken,
		provider: session?.provider,
	};
};
